import gql from 'graphql-tag';

export default gql`
  mutation DeleteTemplate($id: UUID!) {
    deleteContentTemplate(_id: $id)
  }
`;
